module.exports = __webpack_public_path__ + "static/media/entrepreneur-icon.290ee99b.svg";